import { createApp } from 'vue'
import router from './router'
import { store } from './store'
import i18n from './i18n' // 导入上面创建的 i18n 实例
// import ElementPlus from 'element-plus'
// import 'element-plus/dist/index.css'
import '@/assets/styles/index.scss' // 自定义主题色
import App from './App.vue'
import '@/router/permission'

document.title = '数校云析'

const app = createApp(App)
// app.use(ElementPlus)
app.use(i18n)
app.use(store)
app.use(router)
app.mount('#app')
